import styled from 'styled-components';

const ProgressMarkers = styled.div`
  display: flex;
  justify-content: space-between;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export default ProgressMarkers;
